
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!content_migrations.subviews.external_tool_launch";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'content-migrations/subviews/ExternalToolLaunch';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<label class=\"control-label\" for=\"externalToolLaunch\"><strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("content_migrations.subviews.external_tool_launch")
  },data:data},helper ? helper.call(depth0, "course", "Course", options) : helperMissing.call(depth0, "t", "course", "Course", options)))
    + "</strong></label>\n<div class=\"controls\">\n  <button id=\"externalToolLaunch\" class=\"btn\" type=\"button\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("content_migrations.subviews.external_tool_launch")
  },data:data},helper ? helper.call(depth0, "find_a_course", "Find a Course", options) : helperMissing.call(depth0, "t", "find_a_course", "Find a Course", options)))
    + "</button>\n  <span class='file_name'></span>\n</div>";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  